import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import './style.css';
import { ImgPopup } from '@/components/Exporter';
import { CRIcon } from '@/components/crRender';

const MedicalDocuments = ({ admissionDetails }) => {
    const { t } = useTranslation();
    const [viewingDocument, setViewingDocument] = useState("test");
    const imgRef = useRef(null);
    const flatFiles = admissionDetails?.patientData?.files?.flatMap(file => (file?.data));

    const handleViewDocument = (doc) => {
        setViewingDocument(doc);
        imgRef.current.click();
    };

    const getFileIcon = (type) => {
        switch (type) {
            default:
                return (
                    <div className="medical-doc-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                );
        }
    };


    return (
        <>
            <div className="medical-documents-section">
                <h2 className="medical-documents-title">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {t('medical-documents')}
                </h2>

                <div className="medical-documents-list">
                    {flatFiles?.filter(doc => doc.name?.split('/')[0] === 'passport')?.map((doc) => (
                        <div key={doc.id} className="medical-document-item" onClick={() => handleViewDocument(doc)}>
                            {getFileIcon('pdf')}
                            <div className="medical-document-info">
                                <div className="medical-document-name">{doc.name?.split('/')[0]}</div>
                                <div className="medical-document-size pointer">{t("click-to-open")}</div>
                            </div>
                            <CRIcon onClick={() => handleViewDocument(doc)} icon="iconoir:eye-solid" className="medical-document-eye-icon" />
                        </div>
                    ))}
                </div>
            </div>
            <ImgPopup isHideText link={viewingDocument} refImg={imgRef} />
        </>
    );
};

export default MedicalDocuments;

